var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson-test-header"},[_c('div',{staticClass:"lesson-test-header__title"},[_vm._v(_vm._s(_vm.title))]),(typeof _vm.currentQuestionIdx === 'number')?_c('div',{staticClass:"lesson-test-header__position"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }